import { Injectable, signal } from '@angular/core';
import type { Tokens } from '../models/auth.model';

const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'refreshToken';

function readLocalStorage(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeLocalStorage(key: string, value: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch {
    /* storage disabled */
  }
}

@Injectable({ providedIn: 'root' })
export class TokenStore {
  private readonly _accessToken = signal<string | null>(readLocalStorage(ACCESS_TOKEN_KEY));
  private readonly _refreshToken = signal<string | null>(readLocalStorage(REFRESH_TOKEN_KEY));

  readonly accessToken = this._accessToken.asReadonly();
  readonly refreshToken = this._refreshToken.asReadonly();

  setTokens(tokens: Tokens): void {
    writeLocalStorage(ACCESS_TOKEN_KEY, tokens.accessToken);
    writeLocalStorage(REFRESH_TOKEN_KEY, tokens.refreshToken);
    this._accessToken.set(tokens.accessToken);
    this._refreshToken.set(tokens.refreshToken);
  }

  clear(): void {
    writeLocalStorage(ACCESS_TOKEN_KEY, null);
    writeLocalStorage(REFRESH_TOKEN_KEY, null);
    this._accessToken.set(null);
    this._refreshToken.set(null);
  }
}
